import { Stack, useMediaQuery} from '@mui/material';
import Grid from '@mui/material/Grid2';
import Filters from "pages/Faq/components/Filters";
import QuestionList from "pages/Faq/components/QuestionList";
import SearchInput from "components/SearchInput";
import FilterButton from "pages/Faq/components/FilterButton";
import {useQuestionListContext} from "pages/Faq/context/questionContext";
import ContentContainer from "components/ContentContainer";
import Banner from "pages/Faq/components/Banner";


const PageFaq = () => {
  const isDesktop = useMediaQuery(theme => theme.breakpoints.up('xl'))
  const {setSearchInput, searchInput} = useQuestionListContext()

  return (
    <ContentContainer>
      <Grid container columnSpacing={7} rowSpacing={4}>
        <Grid size={{xxs: 12}}>
          <Banner />
        </Grid>
        <Grid size={{xs: 12, xl: 3}}>
          <Filters />
        </Grid>
        <Grid size={{xs: 12, xl: 9}}>
          <Stack spacing={{xs: 4, xl: 5}}>
            <Stack direction={'row'} spacing={4} alignItems={'center'}>
              <SearchInput inputValue={searchInput} setInputValue={setSearchInput}/>
              {!isDesktop && (
                <FilterButton />
              )}
            </Stack>

            <QuestionList />
          </Stack>
        </Grid>
      </Grid>
    </ContentContainer>
  );
};


export default PageFaq;
